export enum TipoObservacionExcelPrecios {
    Error = 0,
    Conflicto = 1,
    SinConflicto = 2
}